import { gql } from "@grandvisionhq/graphql";
const StoreInventoryFragment = gql`
  fragment StoreInventory on Store {
    inventory(sku: $sku) {
      sku
      totalQuantity
      stockIndicator
      items {
        showroomModelAvailable
      }
    }
  }
`;
export {
  StoreInventoryFragment as default
};
//# sourceMappingURL=store-inventory.js.map
